import SectionHeading from "@/pages/home/components/SectionHeading";
import { categories } from "@/mocks/home";

const tintMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-600",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function Categories() {
  return (
    <section id="categories" className="w-full bg-background-100 py-14 md:py-24">
      <div className="w-full px-4 md:px-10">
        <SectionHeading
          eyebrow="我们征集什么"
          title="六类爆料线索，长期开放征集"
          desc="不同类型的线索，需要的凭证也不一样。投稿前可以对照下面的说明，准备好相应的原始材料，核验会快很多。"
        />

        <div className="mt-10 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat, index) => (
            <article
              key={cat.title}
              className="reveal group bg-background-50 rounded-lg border border-background-200 p-5 md:p-7 flex flex-col gap-4 hover:border-primary-300 transition-colors"
              style={{ animationDelay: `${index * 0.06}s` }}
            >
              <span
                className={`w-12 h-12 md:w-14 md:h-14 rounded-md flex items-center justify-center ${tintMap[cat.tint]}`}
              >
                <i className={`${cat.icon} text-2xl md:text-[28px]`}></i>
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">{cat.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600 flex-1">{cat.desc}</p>
              <div className="flex items-center justify-between pt-3 border-t border-background-200">
                <span className="text-xs text-foreground-500">已收线索 {cat.count}</span>
                <a
                  href="#submit"
                  className="text-sm font-medium text-primary-600 hover:text-primary-700 flex items-center gap-1 cursor-pointer whitespace-nowrap"
                >
                  投稿此类
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}